export default __webpack_public_path__ + "static/media/sh2_6.4c616183.jpg";